import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { NavController } from '@ionic/angular';
import { NavigationStore } from '@services/navigation.store';


export const authCanActivate: CanActivateFn = async (route, state): Promise<boolean> => {
  const authService = inject(AuthService);
  const navController = inject(NavController);
  const navigationStore = inject(NavigationStore);

  if (!authService.isAuthenticated) {
    navigationStore.setBackUrl(state.url);
    await navController.navigateBack('/login');
    return false;
  }

  if (route.routeConfig?.path?.includes('registration') || route.routeConfig?.path?.includes('order-details')) {
    return true;
  }

  if (authService.isUserProfileIncomplete) {
    await navController.navigateBack('/registration', {replaceUrl: true});
    return false;
  }

  return true;
};
